<template>
    <main id="print-content">
        <b-overlay :show="loading">
            <!-- Filter Modal -->
            <b-modal v-model="showModalEdit" id="filter-modal" cancel-variant="secondary" ok-:title="$t('Edit')"
              cancel-title="Batal" centered title="Form Ubah">
              <b-form>
                <b-form-group>
                  <label for="level">Level:</label>
                  <b-form-input v-model="nama_level" id="level" type="level" placeholder="Nama level" />
                </b-form-group>
              </b-form>
        
              <template #modal-footer>
                <section class="d-flex justify-content-end align-items-center">
                  <b-button size="sm" class="mr-1" variant="info" @click="submit"> Ubah </b-button>
                  <b-button size="sm" variant="danger" @click="resetForm"> Batal </b-button>
                </section>
              </template>
            </b-modal>
            <!-- / -->
            <b-card no-body>
                <b-tabs align="left" content-class="p-2" fill>
                    <b-tab :title="`Failed Print (${items.length})`" active>
                      <div v-if="failedDocsMessage" class="p-1 alert alert-danger">
                        <b class="d-block mb-1">
                          {{ failedDocsMessage }}
                        </b>
                      </div>
                        <b-row class="justify-content-end">
                          <b-col cols="12" v-if="selectedOrders.length > 0">
                            <div class="d-flex justify-content-end">
                              <b-button title="Cetak Label" size="md" class="mr-1 text-dark"
                                  variant="primary" @click.prevent="printMultiDocument">
                                  <b class="text-dark mr-1">
                                      <feather-icon class="text-dark" icon="PrinterIcon" />
                                  </b>
                                  <span class="text-dark">Cetak Label ({{ selectedOrders.length }})</span>
                              </b-button>
                            </div>
                          </b-col>
                          <b-col md="2" sm="4" class="my-1">
                            <b-form-group class="mb-0">
                              <label class="d-block text-sm-left mr-50">Per page</label>
                              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
                            </b-form-group>
                          </b-col>
                          <b-col md="4" sm="8" class="my-1">
                            <b-form-group class="mb-0 d-flex">
                              <label class="d-inline-block text-sm-left">Tanggal</label>
                              <b-form-input
                                v-model="filterDate" class="form-control" size="sm"
                                type="date"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col md="6" class="my-1">
                            <b-form-group>
                              <label class="d-inline-block text-sm-left">Search</label>
                              <b-input-group size="sm">
                                <b-form-input id="filterInput" v-model="filter" @keyup.enter="getData" type="text" />
                                <b-input-group-append>
                                  <b-button :disabled="!filter" @click="filter = ''">{{ $t('Clear') }}</b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                    
                          <b-col cols="12">
                              <b-table striped hover responsive :per-page="perPage" :items="items"
                                  :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                              >
                                  <template #head(checkbox)>
                                    <b-form-checkbox v-model="allChecked"></b-form-checkbox>
                                  </template>
                                  <template #cell(checkbox)="{ item }">
                                    <b-form-checkbox
                                      v-model="selectedOrders"
                                      :value="item"
                                    ></b-form-checkbox>
                                  </template>
                                  <template #cell(id)="row">
                                      <strong class="text-center">
                                          {{ row.index + 1 }}
                                      </strong>
                                  </template>
                                  <template #cell(externalOrderId)="{ item }">
                                      <b class="d-block">{{ item.externalOrderId }}</b>
                                      <i>STATUS: {{ getOrderStatusLabel(item.order?.orderStatus) }}</i>
                                  </template>
                                  <template #cell(updated_at)="{ item }">
                                      {{ parseISODate(item.updated_at) }}
                                  </template>
                                  <template #cell(message)="{ item }">
                                      {{ item.message }}
                                  </template>
                                  <template #cell(actions)="{item}">
                                      <b-button title="Cetak Label" size="sm" class="mr-1"
                                          variant="primary" @click.prevent="printDocument(item.orderId)">
                                          <b class="text-dark">
                                              <feather-icon class="text-dark" icon="PrinterIcon" />
                                          </b>
                                      </b-button>
                                  </template>
                            </b-table>
                          </b-col>

                        <b-col cols="12">
                            <b-pagination 
                                v-model="currentPage" 
                                :total-rows="totalRows" 
                                :per-page="perPage" 
                                align="center" size="sm" class="my-0" 
                            />
                        </b-col>
                        </b-row>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-overlay>
    </main>
  </template>
  
  <script>
  import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
  import { BTable, BTab, BTabs, BFormCheckbox, BCard, BOverlay, VBTooltip, BAvatar, BBadge, BModal, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton } from "bootstrap-vue";
  import { PDFDocument } from "pdf-lib";

  export default {
    components: {
      VBTooltip,
      BTab, BTabs, 
      BFormCheckbox,
      BCard, BOverlay,
      ToastificationContent,
      BModal,
      BTable,
      BAvatar,
      BBadge,
      BRow,
      BCol,
      BFormGroup,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BButton,
    },
    directives: {
      "b-tooltip": VBTooltip,
    },
    data() {
      return {
        failedDocsMessage: null,
        selectedOrders: [],
        allChecked: false,
        filterDate: null,
        loading: false,
        showModalEdit: false,
        showModalAdd: false,
        id: null,
        nama_level: null,
        perPage: 10,
        pageOptions: [10, 20, 50],
        totalRows: 1,
        currentPage: 1,
        sortBy: "",
        sortDesc: false,
        sortDirection: "asc",
        filter: null,
        filterOn: [],
        infoModal: {
          id: "info-modal",
          title: "",
          content: "",
        },
        fields: [
          {
            key: "checkbox",
            label: "#",
            thStyle: { width: "2%" },
          },
          {
            key: "id",
            label: "No",
          },
          {
            key: "externalOrderId",
            label: "No. Pesanan",
          },
          {
            key: "updated_at",
            label: "Waktu Cetak",
          },
          {
            key: "message",
            label: "Alasan Gagal",
          },
          { key: "actions", label: "Aksi" },
        ],
        items: [],
        status: [
          {
            1: "Current",
            2: "Professional",
            3: "Rejected",
            4: "Resigned",
            5: "Applied",
          },
          {
            1: "light-primary",
            2: "light-success",
            3: "light-danger",
            4: "light-warning",
            5: "light-info",
          },
        ],
      };
    },
    watch: {
      allChecked(val) {
        if (val) {
          this.selectedOrders = this.items;
        } else {
          this.selectedOrders = [];
        }
      },
      currentPage(val) {
          if(val) {
              this.getData();
          }
      },
      perPage(val) {
          if(val) {
              this.getData();
          }
      },
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields.filter((f) => f.sortable).map((f) => ({ text: f.label, value: f.key }));
      },
    },
    mounted() {
      this.filterDate = this.getCurrentDate();
      this.getData();
    },
    methods: {
        getOrderStatusLabel(status) {
            if(!status) {
                return "-";
            }

            return status.replaceAll("_", " ");
        },
        async mergePdfs(links) {
          const pdfDoc = await PDFDocument.create();

          for (const link of links) {
            try {
              // Panggil proxy backend melalui Vuex
              const existingPdfBytes = await this.$store.dispatch(
                "ginee/proxyPrint",
                {
                  url: link,
                }
              );
              const existingPdf = await PDFDocument.load(existingPdfBytes);
              const copiedPages = await pdfDoc.copyPages(
                existingPdf,
                existingPdf.getPageIndices()
              );

              // Tambahkan halaman dari PDF yang sudah diunduh
              copiedPages.forEach((page) => pdfDoc.addPage(page));
            } catch (error) {
              console.error("Error processing PDF from:", link, error);
            }
          }

          // Simpan PDF gabungan
          return await pdfDoc.save();
        },
        printMultiDocument() {
            
          this.$swal({
            title: "Sedang Memproses...",
            html: "Proses: <b>0%</b>",
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
            },
          });

          let pdfLinks = [];
          let failedDocs = [];
          let numberPdf = 0;
          const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

          const updateProgress = (current, total) => {
            const percentage = Math.round((current / total) * 100);
            this.$swal.update({
              html: `Proses: <b>${percentage}%</b>`,
            });

            // Reapply loading state to prevent "OK" button from appearing
            this.$swal.showLoading();
          };

          const fetchWithRetry = async (params, retries = 3, delayMs = 4000) => {
            for (let attempt = 1; attempt <= retries; attempt++) {
              try {
                const response = await this.$store.dispatch("ginee/print", params);
                if (response.link) {
                  return response; // Success
                } else {
                  console.log('No link in response:', { response, params });
                  return null;
                }
              } catch (error) {
                console.error(error.response?.data);
                if (
                  error.response?.status === 400 &&
                  error.response?.data?.message?.includes("PARAMETER_ERROR:Status pesanan tidak mendukung pencetakan Label Pengiriman")
                ) {
                  console.log(`Retrying ${params.orderId}... Attempt ${attempt}/${retries}`);
                  await delay(delayMs);
                } else {
                  throw error; // If it's a different error, don't retry
                }
              }
            }
            console.log(`Failed after ${retries} attempts for`, params.orderId);
            throw new Error(`Failed to fetch PDF for order ${params.orderId} after ${retries} retries`);
          };


          const processSequentially = async () => {
            if (!this.selectedOrders?.length) return; // Prevent errors if array is empty

            for (let index = 0; index < this.selectedOrders.length; index++) {
              const item = this.selectedOrders[index];
              let params = {
                orderId: item.orderId,
                type: "LABEL"
              };

              try {
                const response = await fetchWithRetry(params);
                if (response?.link) {
                  numberPdf += 1;
                  pdfLinks.push(response.link);
                  updateProgress(index + 1, this.selectedOrders.length);
                } else {
                  failedDocs.push(item.externalOrderId); // Store failed document externalOrderId
                }
              } catch (e) {
                failedDocs.push(item.externalOrderId);
                this.displayError(e);
              }

              await delay(1000); // Wait before next request
            }
          };

          processSequentially()
          .then(async () => {
            if (pdfLinks.length > 0) {
              console.log("Final pdfLinks:", pdfLinks);
              try {
                // Merge all PDFs
                const mergedPdf = await this.mergePdfs(pdfLinks);

                // Ensure mergedPdf is an ArrayBuffer
                // if (!(mergedPdf instanceof ArrayBuffer)) {
                //   throw new Error("Invalid merged PDF format");
                // }

                const blob = new Blob([mergedPdf], { type: "application/pdf" });

                let init = await this.$store.dispatch("pesanan/initTaskPrint");
                let taskId = init.taskId;

                const formData = new FormData();
                formData.append("taskId", taskId);
                formData.append("file", blob, "merged.pdf");

                await this.$store.dispatch("pesanan/uploadMergeDoc", formData);

                const url = URL.createObjectURL(blob);
                window.open(url, "_blank"); // Open merged PDF in a new tab
                this.selectedOrders = [];
                this.getData();
              } catch (error) {
                console.error("Error merging PDFs:", error);
                this.$swal({
                  title: "Gagal",
                  text: "Terjadi kesalahan saat menggabungkan PDF.",
                  icon: "error",
                });
              }
            } else {
              this.$swal({
                title: "Gagal",
                text: "Tidak dapat menghasilkan tautan PDF.",
                icon: "error",
              });
            }

            if (failedDocs.length > 0) {
              this.failedDocsMessage = `
                Terdapat order yang gagal dicetak: ${failedDocs.join(", ")}.
              `;
              console.log("Failed Documents:", failedDocs);
            }
          })
          .finally(() => {
            this.$swal.close();
          });
        },
        printDocument(orderId) {
            console.log('orderId', orderId);
            let params = {
                orderId,
                type: "LABEL"
            };
            this.$swal({
                title: "Sedang Memproses...",
                text: "Tunggu sebentar, proses sedang berjalan.",
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                },
            });
            this.$store
            .dispatch("ginee/print", params)
            .then(async (response) => {
                this.$swal.close();
                window.open(response.link, "_blank");
                this.getData();
            })
            .catch((e) => {
                this.$swal.close();
                this.displayError(e);
                return false;
            });
        },
      add() {
        this.id = null;
        this.activeAction = "tambah";
        this.showModalAdd = true;
        this.showModalEdit = false;
      },
      resetForm() {
        this.id = null;
        this.nama_level = null;
        this.showModalAdd = false;
        this.showModalEdit = false;
      },
      submit() {
        if (this.nama_level == null || this.nama_level == "") {
          return false;
        }
        let payload = {
          nama_level: this.nama_level,
        };
  
        if (this.id) {
          payload.id = this.id;
        }
  
        this.$store
          .dispatch("level/save", [payload])
          .then(() => {
            if (this.activeAction == "tambah") {
              this.id = null;
            }
            this.nama_level = null;
            this.showModalAdd = false;
            this.showModalEdit = false;
            this.getData();
          })
          .catch((e) => console.error(e));
      },
      edit(item) {
        let { id, nama_level } = item;
        this.id = id;
        this.nama_level = nama_level;
        this.showModalEdit = true;
      },
        getData() {
            const perPage = parseInt(this.perPage);
            const currentPage = (parseInt(this.currentPage) - 1) * perPage;
            const params = {
                start: currentPage,
                length: perPage
            };

            if(this.filterDate) {
              params.tanggal = this.filterDate;
            }
            if(this.filter) {
              params.search = this.filter.trim();
            }
            this.loading = true;
            this.$store
            .dispatch("pesanan/historyPrintItem", params)
            .then((res) => {
                console.log('response', res);
                this.items = res.data;
                this.totalRows = res.recordsTotal;
                this.loading = false;
            })
            .catch((error) => {
                this.loading = false;
                this.displayError(error);
            });
        },
      resetInfoModal() {
        this.infoModal.title = "";
        this.infoModal.content = "";
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
    },
  };
  </script>
<style>
#print-content .nav-pills .nav-link, .nav-tabs .nav-link {
    justify-content: start !important;
}
</style>
  